import { Pipe, PipeTransform } from '@angular/core';
import { Course } from 'lms-api';

@Pipe({
  name: 'courseStatusFilter'
})
export class CourseStatusFilterPipe implements PipeTransform {

  transform(courses: Course[], ...includeStatuses: any[]): any {
    if (courses == null) return [];
    const filterable = [...courses];

    return filterable.filter(course => includeStatuses.includes(course.userData.Status));
  }

}
